import React, { useEffect, useState, useMemo } from "react";
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { FaPhoneAlt, FaRegEnvelopeOpen, FaRegPaperPlane } from "react-icons/fa";
import { AiOutlinePoweroff, AiOutlineKey } from "react-icons/ai";
import { BsBank } from "react-icons/bs";
import Badge from 'react-bootstrap/Badge';
import Loader from "../../component/loader";
import { Chart } from "react-google-charts";
import Address from './component/address'
import Cookies from "js-cookie";
import { decrpt } from "../../component/encryption";
import axios from "axios";

const options = {
  // title: "NEW ORDER",
  hAxis: { title: "Year", titleTextStyle: { color: "#333" } },
  vAxis: { minValue: 0 },
  chartArea: { width: "60%", height: "75%" },
};

function UserSingle() {
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location, 'location data');
  const [loader, setLoader] = useState(false);
  const [userDeatils, setUserDeatils] = useState();
  const [dashData, setDashData] = useState();
  const [cart, setCart] = useState();
  const [wishList, setWishList] = useState();

  let itemId = location.state && location.state.item;

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const orders = useMemo(() => {
    if (!Array.isArray(userDeatils?.orders)) return [];
    return [...userDeatils.orders].sort((a, b) => Number(b.id || 0) - Number(a.id || 0));
  }, [userDeatils]);

  // Filtered orders by search
  const filteredOrders = useMemo(() => {
    if (!searchText.trim()) return orders;
    const q = searchText.trim().toLowerCase();
    return orders.filter((o) => {
      const orderUuid = String(o.order_uuid || "").toLowerCase();
      const totalPrice = String(o.total_price || "").toLowerCase();
      const id = String(o.id || "").toLowerCase();
      return orderUuid.includes(q) || totalPrice.includes(q) || id.includes(q);
    });
  }, [orders, searchText]);

  // Pagination logic
  const totalItems = filteredOrders.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedOrders = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredOrders.slice(startIndex, endIndex);
  }, [filteredOrders, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  console.log(wishList, 'cnsucnsucn')


  const userDeatilsFetch = async () => {
    try {
      setLoader(true);
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/user/details`, { user_id: itemId })
        .then((response) => {
          console.log(response.data.data.user_details.address, 'check response');
          setUserDeatils(response.data.data.user_details);
          setDashData(response.data);
          setCart(response.data.data.user_details.cart)
          setWishList(response.data.data.user_details.wishlist)
          setLoader(false);
        })
    } catch (err) {
      console.log(err, 'err');
      setLoader(false);
    }
  }
  const userIdSend = (item) => {
    navigate('/order/single', { state: { item } });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    userDeatilsFetch();

  }, []);
  return (
    <div className="main-content">
      {loader ?
        <Loader />
        :
        <>
          {/* New User Registration */}
          <div className="section">
            <div className="row">

              <div className="col-md-12">
                <div className="card mb-3 p-3">
                  <div className="row g-3">
                    {/* Personal Details Column */}
                    <div className="col-lg-7">
                      <h3 className="h1 fw-bold" style={styles.header}>{userDeatils && userDeatils.name}</h3>
                      <p className="text-muted mb-2">Gender: <strong>{userDeatils && userDeatils.gender == "M" ? 'Male' : (userDeatils && userDeatils.gender == "F" ? "Female" : "Not Specified")}</strong></p>
                      <div className="d-flex align-items-center gap-3 flex-wrap mb-2">
                        {userDeatils && userDeatils.mobile && (
                          <span className="d-flex align-items-center gap-1">
                            <FaPhoneAlt className="text-secondary" /> {userDeatils.mobile}
                          </span>
                        )}
                        {userDeatils && userDeatils.mobile && userDeatils.email && (
                          <span className="text-muted">|</span>
                        )}
                        {userDeatils && userDeatils.email && (
                          <span className="d-flex align-items-center gap-1">
                            <FaRegEnvelopeOpen className="text-secondary" /> {userDeatils.email}
                          </span>
                        )}
                      </div>
                      <div className="small text-muted mb-0">
                        {userDeatils && userDeatils.address != null ? (
                          userDeatils.address.map((item, index) => {
                            return (
                              <div key={index} className="d-flex align-items-start gap-1 mb-1">
                                <FaRegPaperPlane className="mt-1 flex-shrink-0 text-secondary" />
                                <span>
                                  {item.address !== null ? (' ' + item.address + ', ') : ''}
                                  {item.land_mark !== null ? (item.land_mark + ', ') : ''}
                                  {item.street !== null ? (item.street + ', ') : ''}
                                  {item.city_name !== null ? (item.city_name + ', ') : ''}
                                  {item.state_name !== null ? item.state_name : ''}
                                  {item.pin ? ` - ${item.pin}` : ''}
                                </span>
                              </div>
                            );
                          })
                        ) : ''}
                      </div>
                      <Address userDeatils={userDeatils && userDeatils} />
                    </div>

                    {/* Customer Bank Details Column */}
                    <div className="col-lg-5">
                      <div className="bg-light p-3 rounded border h-100 shadow-sm">
                        <h6 className="fw-bold text-primary border-bottom pb-2 mb-2 d-flex align-items-center gap-1">
                          <BsBank className="me-1" /> Customer Bank Details
                        </h6>
                        {userDeatils && userDeatils.bank ? (
                          <div className="small">
                            <div className="row g-2">
                              <div className="col-sm-6">
                                <span className="text-muted d-block" style={{ fontSize: '11px' }}>Account Holder</span>
                                <strong className="text-dark">{userDeatils.bank.name || "-"}</strong>
                              </div>
                              <div className="col-sm-6">
                                <span className="text-muted d-block" style={{ fontSize: '11px' }}>Bank Name</span>
                                <strong className="text-dark">{userDeatils.bank.bank_name || userDeatils.bank.bnk_name || "-"}</strong>
                              </div>
                              <div className="col-sm-6">
                                <span className="text-muted d-block" style={{ fontSize: '11px' }}>Account Number</span>
                                <strong className="text-dark font-monospace">{userDeatils.bank.ac_no || "-"}</strong>
                              </div>
                              <div className="col-sm-6">
                                <span className="text-muted d-block" style={{ fontSize: '11px' }}>IFSC Code</span>
                                <strong className="text-dark font-monospace">{userDeatils.bank.ifsc || "-"}</strong>
                              </div>
                              <div className="col-12">
                                <span className="text-muted d-block" style={{ fontSize: '11px' }}>Branch</span>
                                <span className="text-dark">{userDeatils.bank.branch_name || "-"}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="text-muted small py-4 text-center">
                            <em>No bank details added by customer yet.</em>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 my-4">
                <div className="card mb-3 p-2">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <h5>User Order Items</h5>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search by Order ID, Order Amount..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>
                  <div>
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th style={{ maxWidth: 350 }}>Order ID</th>
                          <th>Payment Type</th>
                          <th className="text-center">Order Amount</th>
                          <th className="text-center">Order Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedOrders && paginatedOrders.length > 0 ? (
                          paginatedOrders.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                <td>{item.order_uuid}</td>
                                <td>
                                  {item.payment_type == 2 ? (
                                    <Badge bg="info" text="dark">Cash On Delivery</Badge>
                                  ) : (
                                    <Badge bg="info" text="dark">Online</Badge>
                                  )}
                                </td>
                                <td className="text-center">
                                  <div className="fw-bold text-success" style={{ fontSize: '14px' }}>
                                    ₹ {Number(item.overall_price ?? item.total_price ?? 0).toFixed(2)}
                                  </div>
                                </td>
                                <td className="text-center">
                                  {item.order_status == 1 ? <Badge bg="primary">New</Badge> :
                                    item.order_status == 2 ? <Badge bg="success">Accepted</Badge> :
                                      item.order_status == 6 ? <Badge bg="danger">Canceled</Badge> :
                                        item.order_status == 3 ? <Badge bg="warning">Dispatch</Badge> :
                                          item.order_status == 4 ? <Badge bg="secondary">Out For Delivery</Badge> :
                                            <Badge bg="success">Delivered</Badge>}
                                </td>
                                <td className="text-center">
                                  <button onClick={() => userIdSend(item.id)} className='btn btn-xs btn-primary text-white'>
                                    View Order Detail
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={6} className="text-center">No orders found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > 0 && (
                      <div
                        className="flex items-center justify-between mt-4 px-2"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          marginTop: '1rem',
                          padding: '0 0.5rem',
                          flexWrap: 'wrap',
                          gap: '0.75rem'
                        }}
                      >
                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>Show</span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{
                              padding: '0.25rem 0.5rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              outline: 'none',
                              background: '#fff'
                            }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>entries</span>
                        </div>

                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === 1 ? 0.5 : 1,
                              cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span
                            className="text-sm font-medium px-2 text-gray-700"
                            style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}
                          >
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === totalPages ? 0.5 : 1,
                              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                            }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </div>

  );
}

export default UserSingle;
const styles = {
  header: { textTransform: 'uppercase', color: '#149348', marginBottom: 0 },
  box: { background: '#e1e1e1', borderRadius: 10, paddingLeft: 10, paddingRight: 10, padding: 10, flex: 1, boxShadow: '0 0 5px 0 #868686', border: '2px dotted #fff' },
  boxHeading: { color: '#333', fontWeight: '900', fontSize: 15, marginBottom: 0 },
  boxNumber: { color: 'green', fontWeight: '900', fontSize: 25, marginBottom: 0 },
}
